/* eslint no-param-reassign: "error" */
function toggleClass(el, className) {
  if (el.classList) el.classList.toggle(className);
}

function removeClass(el, className) {
  if (el.classList) el.classList.remove(className);
}

const eventHandler = () => {
  const opener = document.querySelector('.js-articles-list-filter-opener');
  if (opener)
    opener.addEventListener('click', () => {
      const body = document.querySelector('body');
      toggleClass(body, 'isFilterOpen');
    });

  const filterLabels = document.querySelectorAll(
    '.js-articles-list-filter-label'
  );
  Array.prototype.forEach.call(filterLabels, el => {
    el.addEventListener('click', () => {
      const body = document.querySelector('body');
      removeClass(body, 'isFilterOpen');
    });
  });

  document.addEventListener('click', e => {
    const elClass = e.target.classList;
    if (!elClass.contains('keep-filter-open')) {
      const body = document.querySelector('body');
      removeClass(body, 'isFilterOpen');
    }
  });
};

const filterOpener = async () => eventHandler();

export default filterOpener;
